/* eslint-disable @typescript-eslint/no-shadow */
import { add } from 'date-fns';
import { isEmpty } from 'lodash-es';

import { genUuidForCookie } from '~/storeServices/uuidForCookie';

import { makeMutations } from '../helper-functions/store/store';

export const state = () => ({
  data: [],
  quarticCookie: '',
});
export const mutations = {
  ...makeMutations(['data', 'oferty']),
  setRekomendacje(state, newValue) {
    state.data = newValue;
  },
  updateQuarticCookie(state, payload) {
    const cookie = this.$cookies.get('rpl_oferty_dla_ciebie');

    if (isEmpty(cookie)) {
      this.$cookies.set('rpl_oferty_dla_ciebie', payload, {
        expires: add(Date.now(), { years: 1 }),
      });
      state.quarticCookie = payload;
    } else {
      state.quarticCookie = cookie;
    }
  },
};

export const actions = {
  async fetchRekomendacje({ commit, state, dispatch }, payload) {
    dispatch('genCookieForQuartic');
    const rekomendacje = await this.$http.$get(
      `https://restapi.quartic.pl/store/recommendation/?customer=rainbowtours&placementId=1nin7&cookie=${state.quarticCookie}`,
      payload,
    );

    commit('setRekomendacje', rekomendacje.data);
  },
  genCookieForQuartic(context) {
    const uuid = genUuidForCookie();

    context.commit('updateQuarticCookie', uuid);
  },
};
